'use strict';

import type { GlobPlansDisruption } from '../../Entities/Glob/GlobPlansDisruption';
import { EntityCollection } from '../EntityCollection';

export class GlobPlansDisruptionCollection extends EntityCollection<GlobPlansDisruption> {}
